var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('div',{staticClass:"pagination-list"},[(_vm.has_prev_page || _vm.has_next_page)?_c('div',{class:[
        'pagination-arrow',
        {
          is_hidden: !_vm.has_prev_page
        }
      ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.prev_page}},[_c('span',[_vm._v("←")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.visible_list),function(item){return _c('div',{key:item.index,class:[
        'pagination-item',
        {
          is_active: item.is_active,
          is_available: item.is_available,
          is_done: item.is_done,
          is_skipped: item.is_skipped
        }
      ],attrs:{"disabled":_vm.disabled || item.disabled},on:{"click":function($event){return _vm.change_index(item.index)}}},[_vm._v("\n      "+_vm._s(item.index + 1)+"\n    ")])}),_vm._v(" "),(_vm.has_next_page || _vm.has_prev_page)?_c('div',{class:[
        'pagination-arrow',
        {
          is_hidden: !_vm.has_next_page
        }
      ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.next_page}},[_c('span',[_vm._v("→")])]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }